import { useCatalog } from "catalog/Catalog.context";
import { IMG_URL } from "configs";

export default function Image({ src, moSrc, alt, className, ...props }) {
  const { isResponsive } = useCatalog();
  const imgSrc = isResponsive && moSrc ? moSrc : src;

  return <img src={`${IMG_URL}/${imgSrc}`} alt={alt} className={className} {...props} />;
}
